import { Audit } from 'entities/entity';
import { MpsAuditResponse } from '../types';

/**
 * Maps MPS API audit shape (created/lastUpdated with time, userId) to app Audit entity.
 * Shared by campaign, ruleset, and other MPS response adapters.
 */
export function normalizeMpsAudit(audit: MpsAuditResponse | undefined): Audit {
  if (!audit) return {};
  return {
    createdAt: audit.created?.time,
    createdBy: audit.created?.userId,
    lastUpdatedAt: audit.lastUpdated?.time,
    lastUpdatedBy: audit.lastUpdated?.userId,
  };
}
